module.exports = __webpack_public_path__ + "static/media/potential-4.654f18fb.svg";